export function EmptyContentBanner({ text }: { text: string }) {
  return (
    <div className="flex h-full justify-content-center align-items-center text-500 font-bold text-xl">
      {text}
    </div>
  );
}
